import { LinearGradient } from 'expo-linear-gradient'
import React from 'react'
import { Dimensions, Image, TouchableOpacity, View } from 'react-native'

import tournamentGroup from '../../../assets/icons/tournament-group.png'
import { Text } from '../../components'
import styles from './styles'

const window = Dimensions.get('window')

interface GameCardProps {
  isTeacher: boolean
  title: string
  difficulty: string
  seatLeft: number
  color: string
  isLocked: boolean
  isGameOver: boolean
  openDeleteModal: (id: string) => void
  isValidDuration: boolean
  gameId: string
  onRegister: () => void
  isTableFull: boolean
}

const GameCard = (props: GameCardProps) => {
  return (
    <TouchableOpacity
      activeOpacity={1}
      disabled={!props.isTeacher}
      style={styles.gameCardContainer}
      onLongPress={() => props.openDeleteModal(props?.gameId)}
    >
      <View
        style={[
          styles.gameCardImageContainer,
          {
            backgroundColor: props.color
          }
        ]}
      >
        <Image source={tournamentGroup} resizeMode="contain" style={{ width: window.width / 4, height: 98 }} />
        <Text
          tx="common.label"
          txOptions={{ label: props.difficulty }}
          style={[styles.difficulty, { marginBottom: 5 }]}
        />
      </View>
      <View style={styles.tournamentDetailsContainer}>
        <Text numberOfLines={1} tx="common.label" txOptions={{ label: props.title }} style={styles.tournamentTitle} />
        <View style={styles.seatLeftContainer}>
          {props.isValidDuration && !props.isGameOver && !props.isLocked ? (
            <Text
              tx="activeGameScreen.seatsLeft"
              txOptions={{ seats: props.seatLeft > 0 ? props.seatLeft : 0 }}
              style={styles.seatLeft}
            />
          ) : null}
        </View>
        <TouchableOpacity
          style={{ marginVertical: 10, opacity: props.seatLeft === 0 ? 0.5 : 1 }}
          onPress={() => {
            props.onRegister()
          }}
        >
          {props.isGameOver ? (
            <LinearGradient colors={['#B1A7B2', '#77719A']} start={[0, 1]} end={[1, 0]} style={styles.gradientButton}>
              <Text tx="activeGameScreen.gameOver" allowFontScaling={false} style={styles.buttonText} />
            </LinearGradient>
          ) : props.seatLeft > 0 && props.isValidDuration && props.isLocked === false && !props.isTableFull ? (
            <LinearGradient colors={['#49CDF2', '#9444FB']} start={[0, 1]} end={[1, 0]} style={styles.gradientButton}>
              <Text tx="activeGameScreen.register" allowFontScaling={false} style={styles.buttonText} />
            </LinearGradient>
          ) : (
            <LinearGradient colors={['#B1A7B2', '#77719A']} start={[0, 1]} end={[1, 0]} style={styles.gradientButton}>
              <Text tx="activeGameScreen.observer" allowFontScaling={false} style={styles.buttonText} />
            </LinearGradient>
          )}
        </TouchableOpacity>
      </View>
    </TouchableOpacity>
  )
}

export default GameCard
